// i18next bootstrap. Imported once for side effects from src/frontend.tsx
// before the React tree mounts so first paint already has translations
// available. Components consume via `useTranslation()` from `react-i18next`.
//
// Russian is the marketplace's only interface language (build decision D3).
// The buyer-facing site ships Russian-only: the locale is hard-pinned to `ru`,
// there is no language switcher, and no locale detector runs — so a saved
// choice from an earlier build can't flip the UI to another language. The
// en/hy bundles stay imported so any leftover key lookups still resolve, but
// `supportedLngs` keeps them out of the UI (locale pickers auto-hide when only
// one language is supported).
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import hy from "./locales/hy.json";
import ru from "./locales/ru.json";

void i18n.use(initReactI18next).init({
	resources: {
		ru: { translation: ru },
		en: { translation: en },
		hy: { translation: hy },
	},
	lng: "ru",
	fallbackLng: "ru",
	supportedLngs: ["ru"],
	interpolation: { escapeValue: false },
});

export default i18n;
